import { render, staticRenderFns } from "./ot-password-field-wrapper.vue?vue&type=template&id=168a73f8&scoped=true&"
import script from "./ot-password-field-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-password-field-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-password-field-wrapper.vue?vue&type=style&index=0&id=168a73f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a73f8",
  null
  
)

export default component.exports